module.exports = __webpack_public_path__ + "img/inu_gallery5.2b3f00b1.jpg";